export default "__VITE_ASSET__BNvERUUN__"